import styled from "styled-components";

export const ContentNotAvailable = styled.div`
border:1px solid var(--coffee-dark);
color: var(--coffee-light);
line-height: 1.5em;
margin-bottom: 60px;
padding: 30px;
display: flex;
align-items: center;
justify-content: center;
font-family: var(--font-sans-serif);
text-align: center;
font-size: 15px;
font-style: italic;
max-width: 400px;
  margin-left: auto;
  margin-right: auto;
`